export default __webpack_public_path__ + "static/media/Tie_Vote_Icon.6d054277.svg";